import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from '@mui/material'
import SeatStatusBanner from './SeatStatusBanner'
import { SeatInfoCard } from './SeatInfoCard'
import AdminDataCard from './AdminDataCard'
import PaymentCard from './PaymentCard'
import AuditHistoryCard from './AuditHistoryCard'
import React from 'react'
import PropTypes from 'prop-types'

export const adminSeatShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  seat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  rang: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  status: PropTypes.oneOf(['occupied', 'available', 'selected']).isRequired,
  selected_at: PropTypes.string,
  admin_data: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    seats: PropTypes.array,
    rows: PropTypes.array,
    categories: PropTypes.array,
    paid: PropTypes.string,
    admin: PropTypes.bool
  }),
  booking: PropTypes.string
})

export default function SeatDetailsDialog({
  selectedSeat,
  isSmallScreen,
  theme,
  open,
  onClose,
  onSeatAction,
  onEditAdminData,
  showId,
  scheduleId
}) {
  if (!selectedSeat) return null

  return (
    <Dialog open={open} onClose={onClose} maxWidth='md'>
      <DialogTitle>Détails de la réservation</DialogTitle>
      <DialogContent>
        <Box>
          <SeatStatusBanner status={selectedSeat.status} />
          <SeatInfoCard seat={selectedSeat} isSmallScreen={isSmallScreen} />

          <AuditHistoryCard isSmallScreen={isSmallScreen} selectedSeat={selectedSeat} scheduleId={scheduleId} showId={showId} />
          {selectedSeat.admin_data && <AdminDataCard adminData={selectedSeat.admin_data} theme={theme} onEdit={onEditAdminData} />}
          {selectedSeat.booking && selectedSeat.admin_data && (
            <PaymentCard booking={selectedSeat.booking} adminData={selectedSeat.admin_data} />
          )}
        </Box>
      </DialogContent>
      <Divider />
      <DialogActions>
        {selectedSeat.status !== 'selected' && (
          <Button onClick={onSeatAction} variant='contained' color='primary'>
            {selectedSeat.status === 'occupied' ? 'Rendre disponible' : 'Marquer comme réservé'}
          </Button>
        )}
        <Button onClick={onClose}>Fermer</Button>
      </DialogActions>
    </Dialog>
  )
}

SeatDetailsDialog.propTypes = {
  selectedSeat: adminSeatShape,
  isSmallScreen: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSeatAction: PropTypes.func.isRequired,
  onEditAdminData: PropTypes.func.isRequired,
  showId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  scheduleId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}
